import type { FC } from 'react';
import { useAppVersionCheck } from '@/hooks/useAppVersionCheck';

export const AppVersionWatcher: FC = () => {
  useAppVersionCheck();
  return null;
};
